import { render, staticRenderFns } from "./Qygl.vue?vue&type=template&id=ea72f938&scoped=true&"
import script from "./Qygl.vue?vue&type=script&lang=js&"
export * from "./Qygl.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=ea72f938&prod&scoped=true&lang=css&"
import style1 from "./Qygl.vue?vue&type=style&index=1&id=ea72f938&prod&scoped=true&lang=css&"
import style2 from "./Qygl.vue?vue&type=style&index=2&id=ea72f938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72f938",
  null
  
)

export default component.exports